// components/navbar/NotificationMenuButton.tsx

import React, { useState } from 'react';
import notificationIcon from '../../assets/icons/notificationsButton.svg';
import unseenIcon from '../../assets/icons/unseenIcon.svg';
import styles from './Navbar.module.css';
import { useNotificationStatus } from './useNotificationStatus';
import { User } from '../../gql/types';
import NotificationPortalView from '../notification/NotificationPortalView';


interface Props {
    user?: User;
}

const NotificationMenuButton: React.FC<Props> = ({ user }) => {
    const [ isNotificationPortalViewOpen, setIsNotificationPortalViewOpen ] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0);

    const handleOpen = () => setIsNotificationPortalViewOpen(true);
    const handleClose = () => {
        setIsNotificationPortalViewOpen(false);
        setRefreshKey(prev => prev + 1); 
    };

    const { hasUnseenNotification } = useNotificationStatus(user, refreshKey);

    return (
        <>
            <button
                className={`${styles.navbarButton} ${styles.rightSideButton}`}
                onClick={handleOpen}
                data-testid="notification-icon"
            >
                <img src={notificationIcon}/>
                {hasUnseenNotification && <img src={unseenIcon} className={styles.unseenIcon} data-testid="unseen-icon"/>}
            </button>
                
            {isNotificationPortalViewOpen && (
                <NotificationPortalView
                    onCloseNotificationPortalView={handleClose}
                    data-testid="notification-portal"
                />
            )}
        </>
    );
};

export default NotificationMenuButton;